import { useSelector } from 'react-redux';
import { getAllowedUserPermissions } from '../../helpers/common';
import {
  isAdminRole,
  CHILDREN_TAB_FBA_TRANSFERS,
  CHILDREN_TAB_STOCK_LEVELS_AMAZON_FBA,
} from '../../consts/management/users/users';

export default function useStockLevelsAmazonFbaAccess() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  if (isAdminRole(currentUser?.role)) return { canView: true, canEdit: true, canDraft: true };
  const { childIdToAccess } = getAllowedUserPermissions({
    permissions: currentUser?.permissions || [],
  });
  const access = childIdToAccess.get(CHILDREN_TAB_STOCK_LEVELS_AMAZON_FBA);
  const transfers = childIdToAccess.get(CHILDREN_TAB_FBA_TRANSFERS);
  return {
    canView: access === 'view' || access === 'edit',
    canEdit: access === 'edit',
    canDraft: access === 'edit' && transfers === 'edit',
  };
}
